import { useContext } from "react";
import "./DashboardOverview.css"
import { ForMnSteps } from "../common/Common";
import { LocaleContext, LoginContext } from "../common/App";
import { UserType } from "../common/enums";
import { ConsumerContext } from "..";
import { ForFamiliesSteps } from "../website/WebsiteCommon";

export function DashboardOverview(props) {
    const locale = useContext(LocaleContext);
    const login = useContext(LoginContext);
    const consumer = useContext(ConsumerContext);

    return (
        <div className="dashboard_overview">
            <div className="head hi">{locale.msgs.HI + " " + props.userData.first_name + " " + props.userData.last_name}!</div>
            <div className="text_2 margin_top_low_low">{locale.msgs.DASHBOARD_WELCOME}</div>

            { login.userType === UserType.NANNY ?
                <ForMnSteps mode="dashboard" mediationStatus={consumer.mediationStatus}/>
            :
                <ForFamiliesSteps mode="dashboard" mediationStatus={consumer.mediationStatus}/>
            }

            <div className="margin_bottom_middle"></div>
        </div>
    );
}
